

const PromoIcon = () => {


    return (
        <svg className={"svg-icon"} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.125 7.5V19.0986C10.125 19.2221 10.0945 19.3436 10.0363 19.4525C9.97799 19.5614 9.89376 19.6542 9.79103 19.7226L8.76052 20.4097C8.66051 20.4763 8.54596 20.518 8.42649 20.5311C8.30702 20.5443 8.18614 20.5285 8.07404 20.4852C7.96194 20.4418 7.8619 20.3722 7.78234 20.2821C7.70278 20.192 7.64603 20.0841 7.61688 19.9675L6.375 15"
                stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M6.375 14.9994C5.38044 14.9994 4.42661 14.6043 3.72335 13.901C3.02009 13.1978 2.625 12.2439 2.625 11.2494C2.625 10.2548 3.02009 9.30098 3.72335 8.59772C4.42661 7.89446 5.38044 7.49937 6.375 7.49937H10.125C10.125 7.49937 15.2298 7.49937 20.1423 3.37928C20.2515 3.28733 20.3848 3.22848 20.5263 3.20966C20.6679 3.19085 20.8119 3.21284 20.9414 3.27306C21.0708 3.33328 21.1804 3.42922 21.2573 3.5496C21.3341 3.66998 21.3749 3.80979 21.375 3.95259V18.5462C21.3749 18.689 21.3341 18.8288 21.2573 18.9491C21.1804 19.0695 21.0708 19.1655 20.9414 19.2257C20.8119 19.2859 20.6679 19.3079 20.5263 19.2891C20.3848 19.2703 20.2515 19.2114 20.1423 19.1195C15.2298 14.9994 10.125 14.9994 10.125 14.9994H6.375Z"
                stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default PromoIcon